export default "<div class=\"main-content\">\n  <div class=\"content\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n";